(function () {
  'use strict';
  function boot() {
    document.querySelectorAll('.gloss-emboss-product-page').forEach(function (root) {
      if (root.dataset.orderingInitialized) return;
      root.dataset.orderingInitialized = 'true';
      var choice = root.querySelector('[data-artwork-choice]');
      var help = root.querySelector('[data-design-help]');
      var form = root.querySelector('.product-form');
      var artwork = root.querySelector('[data-artwork-files]');
      var status = root.querySelector('[data-path-status]');
      var note = root.querySelector('[data-order-path-note]');
      if (!choice || !help || !form) return;
      var uploadStatus = root.querySelector('[data-upload-status]');
      var bar = root.querySelector('[data-mobile-order-bar]');
      function syncBar() {
        if (!bar) return;
        var price = root.querySelector('.ge-summary-price');
        var quantity = root.querySelector('[data-index="option3"]');
        bar.querySelector('[data-mobile-price]').textContent = price ? price.textContent.replace(/\+ tax/g, '').trim() : '';
        bar.querySelector('[data-mobile-quantity]').textContent = quantity ? quantity.value + ' cards' : '';
      }
      function syncUploads() {
        if (!uploadStatus) return;
        var inputs = Array.from(root.querySelectorAll('input[type="file"]')).filter(function(input){return !input.hasAttribute('data-ai-logo');});
        var selected = inputs.filter(function(input){return input.files && input.files.length;});
        uploadStatus.textContent = selected.length ? (selected.length > 1 ? 'Front and back artwork files selected. ' : 'One artwork file selected. ') + 'Allow uploads to finish before checkout.' : '';
      }
      root.addEventListener('change', function(event){if(event.target.matches('input[type="file"]'))syncUploads();syncBar();});
      if (bar) {
        syncBar();
        if (window.IntersectionObserver) {
          var observer = new IntersectionObserver(function(entries){bar.hidden = entries[0].isIntersecting;}, {threshold:0.15});
          observer.observe(form);
        }
      }

      function motion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      function goToOrder() {
        form.scrollIntoView({ behavior: motion(), block: 'start' });
        var control = form.querySelector('.single-option-selector');
        if (control) control.focus({ preventScroll: true });
      }
      function syncArtworkFields() {
        root.querySelectorAll('.acerill-product-form input, .acerill-product-form select, .acerill-product-form textarea').forEach(function(input){
          if(root.dataset.artworkPath === 'design'){
            if(!input.hasAttribute('data-ge-was-disabled')){input.setAttribute('data-ge-was-disabled',String(input.disabled));input.setAttribute('data-ge-was-required',String(input.required));}
            input.disabled=true;input.required=false;
          } else if(input.hasAttribute('data-ge-was-disabled')){
            input.disabled=input.getAttribute('data-ge-was-disabled') === 'true';input.required=input.getAttribute('data-ge-was-required') === 'true';
            input.removeAttribute('data-ge-was-disabled');input.removeAttribute('data-ge-was-required');
          }
        });
      }
      if(window.MutationObserver){root.querySelectorAll('.acerill-product-form').forEach(function(container){new MutationObserver(syncArtworkFields).observe(container,{childList:true,subtree:true});});}
      choice.querySelectorAll('[data-artwork-path]').forEach(function (button) {
        button.addEventListener('click', function () {
          var path = button.dataset.artworkPath;
          root.dataset.artworkPath = path;
          syncArtworkFields();
          choice.querySelectorAll('[data-artwork-path]').forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
          if (path === 'design') {
            if (uploadStatus) uploadStatus.hidden = true;
            help.open = true;
            status.textContent = 'Design help selected. Choose a concept, template or designer below.';
            help.scrollIntoView({ behavior: motion(), block: 'start' });
          } else {
            if (uploadStatus) uploadStatus.hidden = false;
            if (artwork) artwork.open = true;
            syncUploads();
            var clear = root.querySelector('[data-ai-clear]');
            if (clear && form.querySelector('[name="properties[AI concept reference]"]')) clear.click();
            note.textContent = '';
            help.open = false;
            status.textContent = 'Upload your front and back artwork, review your options and add to cart.';
            if (artwork) artwork.scrollIntoView({ behavior: motion(), block: 'start' });
          }
        });
      });
      root.querySelectorAll('[data-return-order]').forEach(function (button) { button.addEventListener('click', goToOrder); });
      root.addEventListener('ge:concept-selected', function () {
        note.textContent = 'Your AI concept is attached to this order. Design help is complimentary; you approve the final artwork before printing.';
        status.textContent = 'Concept selected. Review your card options and add to cart.';
        help.open = false;
        goToOrder();
      });
      root.addEventListener('ge:concept-cleared', function () { note.textContent = ''; });
      var prompt = root.querySelector('[data-ai-prompt]');
      var logo = root.querySelector('[data-ai-logo]');
      [prompt, logo].forEach(function (input) { if (input) input.addEventListener('change', function () { if (!form.querySelector('[name="properties[AI concept reference]"]')) note.textContent = ''; }); });
      root.querySelectorAll('.single-option-selector').forEach(function (input) { if (input.dataset.index !== 'option3') input.addEventListener('change', function () { note.textContent = ''; }); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

